import React from 'react';

interface FormStatusProps {
  error: string | null;
  success: boolean;
  successMessage: string;
}

const FormStatus: React.FC<FormStatusProps> = ({ error, success, successMessage }) => {
  if (error) {
    return (
      <div className="bg-red-50 text-red-600 p-3 rounded">
        {error}
      </div>
    );
  }

  if (success) {
    return (
      <div className="bg-green-50 text-green-600 p-3 rounded">
        {successMessage}
      </div>
    );
  }

  return null;
};

export default FormStatus;